import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  video: {
    zIndex: 10000000,
    position: 'absolute',
    width: 720,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  }
}));

const VideoModal = ({ content }) => {
  const classes = useStyles();

  return (
    <>
      <video className={classes.video} controls>
        {content}
      </video>
    </>
  );
};

VideoModal.propTypes = {
  content: PropTypes.node
};

export default VideoModal;
